import { API_ENDPOINTS, DINEOUT_CART_API_HOST, GANDALF_API_HOST } from "constants/api";
import { makeApiCall } from "@swiggy-private/js-utils";
import { PlaceOrderParams } from "types";
import { customApiCall, IOptions } from "../utils/api";

export const placeOrder = async (params: PlaceOrderParams, _makeApiCall: typeof makeApiCall) => {
    const options: IOptions = {
        bodyParams: { ...params },
        method: "POST",
    };
    const response = await customApiCall({
        _makeApiCall,
        apiHost: GANDALF_API_HOST,
        apiEndpoint: API_ENDPOINTS.TRACK_ORDER,
        opts: options,
    });

    return response;
};

export const getPaymentOptions = async (
    params: { parentOrderId?: string; restaurantId?: string; tableId?: string },
    _makeApiCall: typeof makeApiCall,
) => {
    const options: IOptions = {
        bodyParams: { ...params },
        method: "POST",
    };
    const response = await customApiCall({
        _makeApiCall,
        apiHost: DINEOUT_CART_API_HOST,
        apiEndpoint: API_ENDPOINTS.GET_PAYMENT_OPTIONS,
        opts: options,
    });
    return response;
};
